import { useDebouncedCallback } from "use-debounce";

export const useDebounce = useDebouncedCallback;
